import { createContext, useContext } from "react";
import { CreditStudyQueryActions, CreditStudyCommandActions } from "../../domain";
import { GqlCreditStudyCommandActions, GqlCreditStudyQueryActions } from "../gql";


type CreditStudyActionsContextT = {
  creditStudyQueryActions: CreditStudyQueryActions;
  creditStudyMutationActions: CreditStudyCommandActions;
};

export const defaultValue: CreditStudyActionsContextT = {
  creditStudyQueryActions: GqlCreditStudyQueryActions,
  creditStudyMutationActions: GqlCreditStudyCommandActions
};

export const creditStudyActionsContext = createContext<CreditStudyActionsContextT>(defaultValue);

export const useCreditStudyActions = (): CreditStudyActionsContextT => useContext(creditStudyActionsContext);
